module.exports = __webpack_public_path__ + "img/lageplan_1280.35ddbcdf.webp";